<div class="flex flex-col gap-6 p-4">
    <!-- Info Section -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-gray-50 dark:bg-zinc-900 rounded-lg">
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-500">{{ 'settings.paymentJustification.detail.nom' | translate }}</span>
            <span class="font-medium">{{ (details()?.societe?.nom) || '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-500">{{ 'settings.paymentJustification.detail.nif' | translate }}</span>
            <span class="font-medium">{{ (details()?.societe?.nif) || '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-500">{{ 'settings.paymentJustification.detail.type' | translate }}</span>
            <span class="font-medium">{{ (details()?.societe?.type?.description) || '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-500">{{ 'settings.paymentJustification.detail.category' | translate }}</span>
            <span class="font-medium">{{ (details()?.societe?.categorieSoumissionnaire?.description) || '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-500">{{ 'settings.paymentJustification.detail.status' | translate }}</span>
            <span class="font-medium">{{ (details()?.societe?.status) || '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-500">{{ 'settings.paymentJustification.detail.dateNif' | translate }}</span>
            <span class="font-medium">{{ (details()?.societe?.dateNif | date:'dd/MM/yyyy HH:mm') || '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-500">{{ 'settings.paymentJustification.detail.dacReference' | translate }}</span>
            <span class="font-medium">{{ (details()?.dacReference) || '-' }}</span>
        </div>
        <div class="flex flex-col gap-1">
            <span class="text-sm text-gray-500">{{ 'settings.paymentJustification.detail.dateLimiteSoumission' | translate }}</span>
            <span class="font-medium">{{ (details()?.dateLimiteSoumission | date:'dd/MM/yyyy HH:mm') || '-' }}</span>
        </div>
    </div>

    <!-- Document Section -->
    <div class="flex flex-col gap-2 h-[500px]">
        <h3 class="font-medium">{{ 'settings.paymentJustification.detail.document' | translate }}</h3>

        <div *ngIf="loadingDoc()" class="flex items-center justify-center h-full bg-gray-100 dark:bg-zinc-800 rounded">
            <span>{{ 'settings.paymentJustification.message.loadingDoc' | translate }}</span>
        </div>

        <div *ngIf="!loadingDoc() && !docUrl()"
            class="flex items-center justify-center h-full bg-gray-100 dark:bg-zinc-800 rounded">
            <span>{{ 'settings.paymentJustification.message.noDoc' | translate }}</span>
        </div>

        <object *ngIf="!loadingDoc() && docUrl()" [data]="docUrl()" type="application/pdf"
            class="w-full h-full rounded border border-gray-200 dark:border-zinc-700">
            <p>{{ 'settings.paymentJustification.message.pdfNotSupported' | translate }}</p>
        </object>
    </div>
</div>